import type { ReactNode } from 'react';
import { AppShell } from '@/layouts/AppShell';
import { useProjectScope } from '@/context/ProjectContext';

export function ScopedPage({
  title,
  extraCrumbs,
  children
}: {
  title: string;
  extraCrumbs?: { label: string; to?: string }[];
  children: ReactNode;
}): JSX.Element {
  const { project, user } = useProjectScope();
  const crumbs = [
    { label: project.name, to: `/p/${project.slug}/dashboard` },
    ...(extraCrumbs ?? []),
    { label: title }
  ];
  return (
    <AppShell project={project} user={user} crumbs={crumbs}>
      {children}
    </AppShell>
  );
}
